const NotificationBell = () => (
  <svg focusable={false} viewBox='0 0 24 24'>
    <path
      fillRule='evenodd'
      d='M10 20h4a2 2 0 1 1-4 0zm1.25-15.709V2.75a.75.75 0 1 1 1.5 0v1.541c3.375.373 6 3.235 6 6.709v6.25h1.5a.75.75 0 1 1 0 1.5H3.75a.75.75 0 1 1 0-1.5h1.5V11a6.751 6.751 0 0 1 6-6.709zm6 12.959V11a5.25 5.25 0 0 0-10.5 0v6.25h10.5z'
    />
  </svg>
);

export default NotificationBell;
